import { ComponentChildren, FunctionalComponent, h } from "preact"
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { ROUTES } from "../constants/Routes";
import { NavMenu } from "./NavMenu";
import { NavLink } from "../components/NavLink";
import { LogoIcon } from "../icons/Logo";
import { UserWidget } from '../components/UserWidget';
import { DelTacoNav } from './del-taco-nav/DelTacoNav';

interface DelYeahContainerInterface {
  htmlTitle: string;
  htmlMetaDescription?: string;
  children?: ComponentChildren;
  IDItemMenuSelected: string;
}

export const breakpoints = {
  sm: '600px',
  md: '960px',
  lg: '1280px',
};

const PageStyled = styled.div`
  background: #F2F2F2;
  padding: 0 0 32px 0;
`;

const LayoutStyled = styled.div`
  max-width: 740px;
  margin: 0 auto;
  padding: 24px;
`
const NavMenuStyled = styled.div`
  padding: 24px 0 0;
  background: white;
  overflow-x: hidden;
  text-align: center;
  @media screen and (max-width: ${breakpoints.md}) {
    padding-top: 55px;
  }
  .nav-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: ${breakpoints.md}) { 
      display: grid;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }
  > svg {
    margin-bottom: 16px;
  }
`;

export const DelYeahContainer: FunctionalComponent<DelYeahContainerInterface> = ({
  htmlTitle,
  htmlMetaDescription,
  children,
  IDItemMenuSelected
}) => {
  return (
    <DelTacoNav>
      <PageStyled>
        <UserWidget/>
        <Helmet>
          <title>{htmlTitle}</title>
          <meta name="description" content={htmlMetaDescription}></meta>
        </Helmet>

        <NavMenuStyled>
          <LogoIcon></LogoIcon>
          <NavMenu>
            {ROUTES.map(item => <NavLink id={item.id} url={item.url} label={item.label} active={(item.id === IDItemMenuSelected)}></NavLink>)}
          </NavMenu>
        </NavMenuStyled>

        {children}
      </PageStyled>
    </DelTacoNav>
  )
}
